import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import brand from '../whitelabel';
import config from '../config';

const BrandedLoginPage = ({ onExploreClick, onLoginSuccess, onSignUpClick, customEvent, currentLanguage, onClose, showExplore = true }) => {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [accountNotFound, setAccountNotFound] = useState(false);

  const handleLoginClick = async () => {
    setError(null);
    setIsLoading(true);
    setAccountNotFound(false);

    try {
        const response = await fetch(config.getApiUrl('auth/login'), {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ email, password })
        });

        const contentType = response.headers.get('content-type');
        let data;

        if (contentType && contentType.includes('application/json')) {
        data = await response.json();
        } else {
        const text = await response.text();
        throw new Error(`Unexpected response: ${text.slice(0, 100)}`);
        }

        if (response.ok) {
        localStorage.setItem('token', data.token);

        const user = data.user;
        const userType =
            user?.userType || data.userType || user?.type || 'default';

        console.log("Login successful for:", user?.email);
        console.log("User type:", userType);

        if (onLoginSuccess) {
            onLoginSuccess(user, data.token);
        }
        } else {
        if (
            data.code === 'auth/user-not-found' ||
            data.message?.toLowerCase().includes('not found') ||
            data.message?.toLowerCase().includes('no account')
        ) {
            setAccountNotFound(true);
        } else {
            setError(data.message || 'Login failed');
        }
        }
    } catch (err) {
        console.error('Login error:', err);
        setError(err.message || 'An error occurred during login.');
    } finally {
        setIsLoading(false);
    }
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center bg-cover bg-center px-4"
      style={{
        backgroundImage:
          brand.brandId === 'masihotels' ? 'url(/bolsena-bg.jpg)' : 'none',
        backgroundColor: brand.colors.background || '#ffffff',
      }}
    >
      <div className="bg-white rounded-2xl shadow-lg px-6 py-8 w-full max-w-sm text-center">
        <div className="flex flex-col items-center justify-center mb-6">
          <img
            src={brand.logo}
            alt="Smart AppKey"
            className="w-64 h-auto mb-4"
          />
          {brand.brandId !== 'default' && brand.secondaryLogo && (
            <img
              src={brand.secondaryLogo}
              alt={`${brand.name} Seconday Logo`}
              className="h-32 sm:h-32 opacity-80"
            />
          )}
        </div>

        <h2 className="text-xl font-bold mb-1">{t('login.welcome')}</h2>
        <p className="text-sm text-gray-600 mb-6">{t('login.subtitle')}</p>

        <input
          type="email"
          placeholder={t('login.email')}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full mb-3 px-4 py-2 rounded-full border border-gray-300 text-sm"
        />

        <input
          type="password"
          placeholder={t('login.password')}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full mb-2 px-4 py-2 rounded-full border border-gray-300 text-sm"
        />

        <div className="flex justify-between items-center mb-4 text-xs text-gray-500">
          <label>
            <input type="checkbox" checked={rememberMe} onChange={() => setRememberMe(!rememberMe)} className="mr-1" />
            {t('login.rememberMe')}
          </label>
          <a href="#" className="hover:underline">{t('login.forgotPassword')}</a>
        </div>

        {error && <p className="text-red-600 text-sm mb-2">{error}</p>}

        {accountNotFound && (
            <p className="text-red-600 text-sm mb-2">
                {t('login.accountNotFound') || 'Account not found. Please register.'}
            </p>
        )}

        <button
            onClick={handleLoginClick}
            disabled={isLoading}
            className={`w-full py-2 rounded-full text-white font-semibold mb-3 transition-opacity duration-300 ${
                isLoading ? 'opacity-50 cursor-not-allowed' : 'hover:opacity-90'
            }`}
            style={{ backgroundColor: brand.colors.accent }}
            >
            {isLoading ? t('login.loading') : t('login.loginButton')}
        </button>

        {showExplore && (
          <button
            onClick={onExploreClick}
            className="w-full py-2 rounded-full text-white font-semibold"
            style={{ backgroundColor: brand.colors.explore || '#000000' }}
          >
            {t('login.exploreButton')}
          </button>
        )}

        <p className="text-xs text-gray-500 mt-4">
          {t('login.noAccount')}{' '}
          <a
            href="#"
            onClick={(e) => {
              //e.preventDefault();           // prevent page jump
              //console.log('Sign up link clicked');
              onSignUpClick();              // trigger original logic
            }}
            className="text-blue-600 font-medium"
          >
            {t('login.register')}
          </a>
        </p>

        {brand.secondaryLogo && (
          <div className="mt-6 flex items-center justify-center gap-1 text-xs">
            <span>{t('login.poweredBy')}</span>
            <img src={brand.logoSAK} alt="Logo SAK" className="h-4" />
          </div>
        )}
      </div>
    </div>
  );
};

export default BrandedLoginPage;
